import React, { memo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { TagAvailableOnEnum } from '@/types/schema';

import { SelectedTagValues, TagsMenuItem } from '../../types';
import AddTags from '../AddTags';
import AttachedTags from '../AttachedTags';

function AttachTags({
  tags,
  onTagChange,
  selectedTagValues,
  onTagsValueChange,
  availableOn,
  error,
  EmptyState,
  isSharedItem,
  fetchTagWithProviders,
  onRemoveTag,
  subWorkspaceIds,
  readonly,
}: {
  tags?: TagsMenuItem[];
  onTagChange: (tags: TagsMenuItem[]) => void;
  onRemoveTag: (tagId: string) => void;
  onTagsValueChange: (tags: SelectedTagValues) => void;
  selectedTagValues?: SelectedTagValues;
  availableOn?: TagAvailableOnEnum[];
  error?: string;
  EmptyState?: JSX.Element;
  isSharedItem?: boolean;
  fetchTagWithProviders?: boolean;
  subWorkspaceIds?: string[];
  readonly?: boolean;
}) {
  useTranslation('Tags');
  return (
    <>
      <AddTags
        EmptyState={EmptyState}
        availableOn={availableOn}
        disabled={readonly}
        fetchTagWithProviders={fetchTagWithProviders}
        isSharedItem={isSharedItem}
        subWorkspaceIds={subWorkspaceIds}
        tags={tags}
        onChange={onTagChange}
      />
      <AttachedTags
        error={error}
        isSharedItem={isSharedItem}
        readOnly={readonly}
        selectedTagValues={selectedTagValues}
        tags={tags}
        onRemoveTag={onRemoveTag}
        onTagsValueChange={onTagsValueChange}
      />
    </>
  );
}

export default memo(AttachTags);
